import {ALLOWED_LANGUAGES, BASE_URL} from "modules/constants";

export const prepareLanguageForRouter = () => {
	const splitPath = window.location.pathname.split("/").filter(Boolean);

	const languagePath = splitPath[1];

	if (languagePath && ALLOWED_LANGUAGES.includes(languagePath) && languagePath !== "en") {
		return `${BASE_URL}/${languagePath}`;
	}

	return BASE_URL;
};

const changeLangToDefault = (oldLang: string) => {
	const newPath = window.location.pathname.replace(`${BASE_URL}/${oldLang}`, `${BASE_URL}`);
	window.location.replace(newPath);
};

export const changeRouteLanguage = (oldLang: string, newLang: string) => {
	const isPathContainsLang = window.location.pathname.includes(`${BASE_URL}/${oldLang}`);

	if (newLang === "en") {
		changeLangToDefault(oldLang);
		return;
	}

	if (isPathContainsLang) {
		const newPath = window.location.pathname.replace(
			`${BASE_URL}/${oldLang}`,
			`${BASE_URL}/${newLang}`
		);
		window.location.replace(newPath);
		return;
	}

	const newPath = window.location.pathname.replace(`${BASE_URL}`, `${BASE_URL}/${newLang}`);
	window.location.replace(newPath);
};
